/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usermenu_AdminInputs */

const en_usermenu_admin = /** @type {(inputs: Usermenu_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Admin dashboard`)
};

const id_usermenu_admin = /** @type {(inputs: Usermenu_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dasbor admin`)
};

/**
* | output |
* | --- |
* | "Admin dashboard" |
*
* @param {Usermenu_AdminInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const usermenu_admin = /** @type {((inputs?: Usermenu_AdminInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usermenu_AdminInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_usermenu_admin(inputs)
	return en_usermenu_admin(inputs)
});